import {Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewChild} from '@angular/core';
import {NgIf, Location} from "@angular/common";
import {TranslateModule} from "@ngx-translate/core";
import {MatDialog} from "@angular/material/dialog";
//Services
import {AuthService} from "@services/auth/auth.service";
//Components
import {BonusInfoDialogComponent} from "../../../shared-modules/global/bonus-info-dialog/bonus-info-dialog.component";
import {SearchDialogComponent} from "../../search-dialog/search-dialog.component";
import {MobileAddressSelectionComponent} from "../../address-selection/mobile-address-selection/mobile-address-selection.component";
//Pipes
import {PriceSpacesPipe} from "../../../pipes/string-methods/price-spaces.pipe";
import {
  MobileNavigationBackButtonActionsBasedEnum,
  MobileNavigationBackButtonTypeEnum
} from "@interfaces/components/enums/navigation-back-button-type.enum";
import {MobileActionsInterface} from "@interfaces/components/mobile-actions.interface";
import {
  BottomNavbarForAddressSelectionComponent
} from "../bottom-navbar-for-address-selection/bottom-navbar-for-address-selection.component";
import {Router} from "@angular/router";
import CyrillicToTranslit from "cyrillic-to-translit-js";
import {CityService} from "@services/city/city.service";
import {GlobalSubscriptionService} from "@services/subscriptions/global-subscription.service";
import {UpdateSubscriptionTypesEnum} from "@interfaces/orders/enums/update-subscription-types.enum";
import {FavoriteAddressInterface} from "@interfaces/orders/favorite-address.interface";
import {CityInterface} from "@interfaces/components/cities.interface";

@Component({
  selector: 'app-top-navbar',
  standalone: true,
  imports: [
    NgIf,
    TranslateModule,
    PriceSpacesPipe,
    SearchDialogComponent,
    BottomNavbarForAddressSelectionComponent,
    MobileAddressSelectionComponent
  ],
  templateUrl: './top-navbar.component.html',
  styleUrl: './top-navbar.component.scss'
})
export class TopNavbarComponent implements OnChanges {
  @ViewChild(MobileAddressSelectionComponent) mobileAddrRef?: MobileAddressSelectionComponent;
  @Output() changeType = new EventEmitter<MobileNavigationBackButtonTypeEnum>();
  @Output() selectAddressToDeliverEvent = new EventEmitter<boolean>();
  @Output() mobileAddressConfirmed = new EventEmitter<{ address: FavoriteAddressInterface } | { city: CityInterface }>();
  @Output() mobileAddressClosed = new EventEmitter<void>();
  @Input() currentType!: MobileNavigationBackButtonTypeEnum;
  @Input() favoriteValue = false;
  @Input() selectedData!: { address: FavoriteAddressInterface } | { city: CityInterface };
  @Input() showMobileAddressSelection = false;
  bonusAmount!: number;
  open = false;
  keepLastType: MobileNavigationBackButtonTypeEnum | null = null;
  keepLastTypeForAddr: MobileNavigationBackButtonTypeEnum | null = null;
  dataForShowIconsAndActions!: MobileActionsInterface;
  isAuthorizedUser = false;

  constructor(private authService: AuthService,
              private dialog: MatDialog,
              private location: Location,
              private router: Router,
              private cityService: CityService,
              private globalSubscriptionService: GlobalSubscriptionService
  ) {
    const userInfo = this.authService.getUserInfo();
    this.isAuthorizedUser = !!userInfo;
    if (!userInfo || !userInfo.bonusAmount) {
      return;
    }
    this.bonusAmount = userInfo.bonusAmount;
  }

  ngOnChanges(changes: SimpleChanges) {
    this.dataForShowIconsAndActions = MobileNavigationBackButtonActionsBasedEnum[this.currentType];

    if ('showMobileAddressSelection' in changes) {
      if (this.showMobileAddressSelection && !this.keepLastTypeForAddr) {
        this.keepLastTypeForAddr = this.currentType;
        this.changeType.emit(MobileNavigationBackButtonTypeEnum.ONLY_BACK);
      } else if (!this.showMobileAddressSelection && this.keepLastTypeForAddr) {
        this.changeType.emit(this.keepLastTypeForAddr);
        this.keepLastTypeForAddr = null;
      }
    }
  }

  backButtonClick(): void {
    if (this.open) {
      this.openOrCloseSearchComponent(false);
    } else if (this.showMobileAddressSelection) {
      const handled = this.mobileAddrRef?.handleBackPress();
      if (!handled) {
        this.mobileAddressClosed.emit();
      }
    } else {
      this.location.back();
    }
  }

  toggleFavorite(): void {
    if (!this.isAuthorizedUser) {
      return;
    }
    this.globalSubscriptionService.sendMessage(UpdateSubscriptionTypesEnum.TOGGLE_FAVORITE_FOR_PRODUCT)
  }

  mainPage(): void {
    if (this.open) {
      this.openOrCloseSearchComponent(false);
    }
    this.navigateMainPage();
  }

  private navigateMainPage(): void {
    const cityName = CyrillicToTranslit().transform(this.cityService.getCityName(), "-").toLowerCase();

    this.router.navigate(['/' + cityName])
  }

  openOrCloseSearchComponent(openOrClose: boolean): void {
    this.open = openOrClose;
    if (this.open && !this.keepLastType) {
      this.keepLastType = this.currentType;
      this.changeType.emit(MobileNavigationBackButtonTypeEnum.ONLY_BACK);
    } else if (this.keepLastType) {
      this.changeType.emit(this.keepLastType);
      this.keepLastType = null;
    }
  }

  openBonusInfoDialog(): void {
    const dialogRef = this.dialog.open(BonusInfoDialogComponent, {
      width: '512px',
      height: 'auto',
      data: this.authService.getUserInfo()
    });
    dialogRef.afterClosed().subscribe((data?: boolean) => {
      if (!data) {
        return;
      }
      this.authService.checkTokenAndRedirectToAuth();
    })
  }

}
